export { default as HomeePage } from "./View";
export { default as PageHomeProducts } from "./PageProducts";
export { default as PageHomeSaleProducts } from "./PageSaleProducts";